import type { PresentationRequest, SceneState } from "./types";

export type InterruptionDecision = "interrupt" | "queue" | "discard";
export function interruptionDecision(current: SceneState | null, incoming: PresentationRequest, now = Date.now()): InterruptionDecision {
  if (!current || current.request.kind === "ambient") return "interrupt";
  if (incoming.expiresAt !== undefined && incoming.expiresAt <= now) return "discard";
  if (current.request.kind === "ceremony" && incoming.kind !== "system" && incoming.kind !== "fullscreen-media") return "queue";
  if (current.request.type === "effect" && incoming.type !== "system") return "queue";
  if (incoming.priority > current.request.priority) return "interrupt";
  if (incoming.type === "gallery" && ["poll", "crowd", "effect"].includes(current.request.type)) return "queue";
  if (incoming.type === "music" && current.request.type === "poll") return "discard";
  return "queue";
}
